import React from 'react';

const Week2Newsletter: React.FC = () => {
  return (
    <div className="newsletter-archive">
      <div className="newspaper-container">
        <div className="newspaper-header">
          <div className="newspaper-masthead">
            <h1 className="newspaper-title">AMBERWOOD FANTASY TIMES</h1>
            <div className="newspaper-subtitle">The Premier Source for Fantasy Football News & Analysis</div>
            <div className="newspaper-meta">
              <span className="edition">Week 2 Edition</span>
              <span className="date">September 2025</span>
              <span className="price">FREE</span>
            </div>
          </div>
        </div>

        <div className="newspaper-content">
          <div className="main-story">
            <h2 className="headline">Week 2 in the Books: Comebacks, Collapses, and Chaos</h2>
            <div className="byline">By the Office of the Commissioner</div>

            <div className="center-image" style={{marginBottom: '30px', textAlign: 'center', width: '100%'}}>
              <div style={{border: '1px solid #ddd', padding: '20px', borderRadius: '8px', backgroundColor: '#f9f9f9', boxShadow: '0 2px 4px rgba(0,0,0,0.1)', display: 'inline-block', maxWidth: '700px', width: '100%'}}>
                <img src="/IMG_3622.WEBP" alt="Week 2 Highlights" style={{width: '100%', maxWidth: '680px', height: 'auto', border: '2px solid #333', borderRadius: '4px'}} />
                <div className="draft-caption" style={{fontSize: '12px', fontStyle: 'italic', textAlign: 'center', marginTop: '10px'}}>
                  Every head must bow, every tongue must confess Pranav Jain is the greatest of all time
                </div>
              </div>
            </div>

            <div className="story-layout">
              <div className="story-column">
                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>🌟 Week 2 Summary</h3>
                <p>Week 2 was the week of redemption and revenge, as previously struggling teams exploded for massive performances while last week's heroes fell back to earth. Elite wide receiver performances dominated the landscape, with Ja'Marr Chase's 36.50-point redemption and Amon-Ra St. Brown's 39.20-point explosion leading the charge, proving that WR1s can single-handedly flip entire matchups.</p>
                <p>Running back disasters killed championship dreams, as Derrick Henry's shocking 1.30-point dud turned last week's league leader into this week's biggest disappointment, showing that even the most reliable fantasy assets can disappear without warning.</p>

                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>📊 Week 2 Matchup Recap</h3>

                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>🔥 High-Scoring Explosions</h3>

                <div className="matchup-result">
                  <h4>"CHASE REDEEMED: From Zero to Hero with 36.50-Point Masterpiece" swahili28 (176.64) def. akhilmetukuru (129.43)</h4>
                  <p><strong>Winner Analysis:</strong> swahili28's 176 points represent the week's highest total, powered by Ja'Marr Chase's incredible 36.50-point bounce-back performance. After last week's 4.60-point disaster, Chase reminded everyone why he's elite with a statement game that single-handedly carried this team to victory.</p>
                  <p><strong>Loser Analysis:</strong> akhilmetukuru's 129 points would have been competitive in most weeks, but they faced the Chase explosion. This team continues to struggle with consistency despite having talented pieces.</p>
                </div>

                <div className="matchup-result">
                  <h4>"CMC CARRIES ON: McCaffrey's 22.70 Powers Dominant Victory" ankithe (171.60) def. SahitReddi (123.49)</h4>
                  <p><strong>Winner Analysis:</strong> ankithe's 171 points were anchored by Christian McCaffrey's reliable 22.70 points, with an explosion from Malik Nabers. This team is starting to look like a legitimate championship contender with balanced scoring.</p>
                  <p><strong>Loser Analysis:</strong> SahitReddi's 123 points represent another disappointing week from a talented roster. This team has elite players but can't seem to put together complete performances.</p>
                </div>

                <div className="matchup-result">
                  <h4>"SUN GOD SHINES: ARSB's 39.20-Point Explosion Dominates" pranav4789 (161.90) def. kulkdaddy47 (101.98)</h4>
                  <p><strong>Winner Analysis:</strong> pranav4789 got revenge for last week's loss with Amon-Ra St. Brown's monster 39.20-point performance - the week's highest individual score. After last week's disappointing 8.50 points, ARSB reminded everyone why he's a WR1.</p>
                  <p><strong>Loser Analysis:</strong> kulkdaddy47's championship hopes took a hit with just 101 points. Last week's heroes became this week's zeros as the depth that saved them in Week 1 completely failed them.</p>
                </div>
              </div>

              <div className="story-column">
                <h3 style={{fontSize: '20px', textDecoration: 'underline'}}>⚔️ Competitive Battles</h3>

                <div className="matchup-result">
                  <h4>"REVENGE SERVED COLD: audumula Bounces Back from Week 1 Heartbreak" audumula (134.97) def. abhishekD (93.64)</h4>
                  <p><strong>Winner Analysis:</strong> audumula got their revenge with 134 points, proving last week's loss was just bad luck. This team showed great resilience bouncing back from a tough Week 1 defeat.</p>
                  <p><strong>Loser Analysis:</strong> abhishekD's stunning collapse from 166 to 93 points represents the week's most shocking fall. Derrick Henry's 1.30-point disaster and Jalen Hurts' quiet 10.54 points turned last week's heroes into near zero's.</p>
                </div>

                <div className="matchup-result">
                  <h4>"MIRACLE COMEBACK: taahakm Strikes Again with Another Lucky Win" taahakm (133.85) def. roshik (102.20)</h4>
                  <p><strong>Winner Analysis:</strong> taahakm improved dramatically to 133 points while still maintaining their supernatural luck. This team is starting to put together skill and luck, which we all know is an undefeated combo in fantasy football</p>
                  <p><strong>Loser Analysis:</strong> roshik's 102 points represent a disappointing follow-up to their strong Week 1. Saquon Barkley and the supporting cast failed to deliver when needed.</p>
                </div>

                <div className="matchup-result">
                  <h4>"STEADY EDDIE: pranavj20 Grinds Out Another Victory" pranavj20 (141.80) def. abhiu (110.47)</h4>
                  <p><strong>Winner Analysis:</strong> pranavj20 continued their winning ways with 141 points, showing consistent performance throughout the whole roster. His team is just scratching the surface of their championship ceiling.</p>
                  <p><strong>Loser Analysis:</strong> abhiu's 110 points show that the team might be in trouble. Jefferson will have to step up, but there are some talented options on his bench.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="team-analysis">
            <h2 className="section-headline">🏆 Power Rankings (Post-Week 2)</h2>

            <div className="power-rankings-section">
              <h3>Tier 1: Championship Contenders</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>1. ankithe (2-0, 311 PF)</h4>
                  <p><strong>Strengths:</strong> CMC's consistent excellence (22.70 pts), undefeated record, balanced scoring</p>
                  <p><strong>Concerns:</strong> Heavy reliance on injury-prone players, depth questions</p>
                  <p><strong>Week 2 Performance:</strong> Dominant 171-point victory showcasing championship ceiling</p>
                </div>

                <div className="team-card">
                  <h4>2. pranavj20 (2-0, 269 PF)</h4>
                  <p><strong>Strengths:</strong> Perfect record, consistent production, clutch performances</p>
                  <p><strong>Concerns:</strong> older RB room with past injury concerns</p>
                  <p><strong>Week 2 Performance:</strong> Workmanlike 141-point win - knows how to get it done</p>
                </div>

                <div className="team-card">
                  <h4>3. swahili28 (1-1, 259 PF)</h4>
                  <p><strong>Strengths:</strong> Ja'Marr Chase's 36.50-point explosion shows elite ceiling potential</p>
                  <p><strong>Concerns:</strong> Inconsistency between weeks, boom-or-bust roster construction</p>
                  <p><strong>Week 2 Performance:</strong> Week's highest total (176 pts) - when they hit, they hit big</p>
                </div>
              </div>

              <h3>Tier 2: Playoff Contenders</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>4. pranav4789 (1-1, 294 PF)</h4>
                  <p><strong>Strengths:</strong> 2nd highest points for in league, ARSB's 39.20-point ceiling game</p>
                  <p><strong>Concerns:</strong> RB development needed, depth concerns</p>
                  <p><strong>Week 2 Performance:</strong> Explosive 161-point revenge game - this team has firepower</p>
                </div>

                <div className="team-card">
                  <h4>5. taahakm (2-0, 242 PF)</h4>
                  <p><strong>Strengths:</strong> Undefeated record, improved scoring, clutch gene activated</p>
                  <p><strong>Concerns:</strong> Still relatively low ceiling, relies on opponent mistakes</p>
                  <p><strong>Week 2 Performance:</strong> Much-improved 133 points - maybe the early luck was skill?</p>
                </div>

                <div className="team-card">
                  <h4>6. audumula (1-1, 272 PF)</h4>
                  <p><strong>Strengths:</strong> Bounced back strong with 134 points, good total points for</p>
                  <p><strong>Concerns:</strong> Inconsistent weekly ceiling, needs more explosive plays</p>
                  <p><strong>Week 2 Performance:</strong> Solid revenge win showing mental toughness</p>
                </div>
              </div>

              <h3>Tier 3: Bubble Teams</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>7. abhishekD (1-1, 259 PF)</h4>
                  <p><strong>Strengths:</strong> Still has elite talent, Week 1 showed championship ceiling</p>
                  <p><strong>Concerns:</strong> Derrick Henry's 1.30-point disaster, dramatic inconsistency</p>
                  <p><strong>Week 2 Performance:</strong> Shocking 93-point collapse - major red flags</p>
                </div>

                <div className="team-card">
                  <h4>8. roshik (1-1, 257 PF)</h4>
                  <p><strong>Strengths:</strong> Solid roster construction, proven players</p>
                  <p><strong>Concerns:</strong> Failed to capitalize on favorable matchups, depth issues</p>
                  <p><strong>Week 2 Performance:</strong> Disappointing 102 points after promising Week 1</p>
                </div>

                <div className="team-card">
                  <h4>9. kulkdaddy47 (1-1, 254 PF)</h4>
                  <p><strong>Strengths:</strong> Championship experience, clutch performers</p>
                  <p><strong>Concerns:</strong> 101-point disaster shows floor concerns, aging roster</p>
                  <p><strong>Week 2 Performance:</strong> Massive letdown after strong Week 1 showing</p>
                </div>
              </div>

              <h3>Tier 4: Rebuild Territory</h3>
              <div className="teams-grid">
                <div className="team-card">
                  <h4>10. abhiu (0-2, 234 PF)</h4>
                  <p><strong>Strengths:</strong> Young talent with upside for a playoff stretch run</p>
                  <p><strong>Concerns:</strong> Inconsistent QB play, rookie growing pains showing</p>
                  <p><strong>Week 2 Performance:</strong> Slight improvement but still not enough production</p>
                </div>

                <div className="team-card">
                  <h4>11. SahitReddi (0-2, 230 PF)</h4>
                  <p><strong>Strengths:</strong> Elite roster talent on paper, bounce-back potential</p>
                  <p><strong>Concerns:</strong> Multiple weeks of underperformance from stars, QB1 gone for the year</p>
                  <p><strong>Week 2 Performance:</strong> Another disappointing 123 points despite talent</p>
                </div>

                <div className="team-card">
                  <h4>12. akhilmetukuru (0-2, 231 PF)</h4>
                  <p><strong>Strengths:</strong> Some individual bright spots, room for improvement</p>
                  <p><strong>Concerns:</strong> 0-2 record with limited ceiling performances</p>
                  <p><strong>Week 2 Performance:</strong> Decent 129 points but faced Chase explosion</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mickey-award">
            <h2 className="section-headline">🤡 Mickey of the Week Award (Maximum Shame Edition)</h2>

            <div className="award-section">
              <h3>"Winner": abhishekD - The Spectacular Collapse</h3>
              <p>Ladies and gentlemen, we have witnessed fantasy football history in the making.</p>

              <div className="collapse-stats">
                <h4>The Fall from Grace:</h4>
                <ul>
                  <li>Week 1: 166.03 points (League Leader, King of the Mountain)</li>
                  <li>Week 2: 93.64 points (League Basement Dweller, Emperor of Embarrassment)</li>
                  <li><strong>NET COLLAPSE: -72.39 points - the largest week-over-week drop in league history</strong></li>
                </ul>
              </div>

              <div className="lineup-disaster">
                <h4>Lineup Disaster Analysis:</h4>
                <ul>
                  <li>Derrick Henry went from 29.20 points to 1.30 points - that's a 27.90-point swing from ONE PLAYER</li>
                  <li>Jalen Hurts dropped from 24.28 to 10.54 points - even the "reliable" QB abandoned ship</li>
                  <li>This team essentially lost 40+ points from just two players while everyone else in the league was improving</li>
                  <li>Started the same roster construction that dominated Week 1, proving that sometimes lightning doesn't strike twice - it electrocutes you</li>
                </ul>
              </div>

              <div className="ultimate-irony">
                <h4>The Ultimate Irony:</h4>
                <ul>
                  <li>Beat pranav4789 by 33 points in Week 1, then lost to audumula by 41 points in Week 2</li>
                  <li>Went from having the week's highest score to having the week's LOWEST score</li>
                  <li>This is like winning the lottery and then immediately losing your ticket in a hurricane</li>
                </ul>
              </div>
            </div>

            <div className="bonus-award">
              <h3>🤡 Bonus Mickey Award - "Worst Trade of the Century Edition"</h3>
              <h4>"Winner": abhiu (Abhiram) - The Trade Terrorist</h4>
              <p>Just when you thought this week couldn't get more embarrassing for anyone, abhiu decided to hold our beer and commit what can only be described as fantasy football terrorism against his own team. In a move that will be studied in "How to Destroy Your Championship Dreams 101" courses for decades to come, abhiu traded away Lamar Jackson AND Jaxson Smith-Njigba to pranavj20 for Justin Jefferson and J.J. McCarthy.</p>

              <div className="trade-breakdown">
                <h4>Breaking Down This Disaster:</h4>
                <ul>
                  <li><strong>Gave Away:</strong> Lamar Jackson (elite dual-threat QB, consistent 20+ point floor) + JSN (performing as a clear WR1)</li>
                  <li><strong>Received:</strong> Justin Jefferson (admittedly elite, but facing major uncertainty at QB) + J.J. McCarthy (Young QB who is now injured)</li>
                </ul>
              </div>

              <div className="aftermath-analysis">
                <h4>The Aftermath Analysis:</h4>
                <ul>
                  <li>pranavj20 now has Lamar Jackson to what was already considered the top team - that's basically cheating</li>
                  <li>abhiu is banking their entire season on Justin Jefferson being the best player in fantasy, while his starting quarterback is now Carson Wentz....</li>
                  <li>This trade single-handedly shifted the championship odds in the league</li>
                </ul>
              </div>

              <p><strong>Expert Commentary:</strong> "This is like trading a Ferrari and a motorcycle for a Lamborghini and a bicycle. Sure, the Lamborghini is nice, but good luck getting to work every day on that bicycle." - Fantasy Football Anonymous</p>
              <p>This bonus Mickey Award comes with a complimentary "Fantasy Trade Evaluation for Dummies" book and a restraining order preventing abhiu from making any more trades without adult supervision.</p>
            </div>
          </div>

          <div className="week-preview">
            <h2 className="section-headline">🔮 Week 3 Matchup Preview</h2>

            <div className="preview-section">
              <h3>🔥 Marquee Matchups</h3>

              <div className="matchup-preview" style={{backgroundColor: '#f9f9f9', border: '2px solid #000', borderRadius: '4px', padding: '10px', margin: '10px 0'}}>
                <h4>ankithe vs pranavj20</h4>
                <p><strong>Key Storylines:</strong> Battle of the undefeateds! Two 2-0 teams clash in what has to be the game of the week.</p>
                <p><strong>X-Factors:</strong> Jayden Daniel's injury may be the defining factor here. Pranavj20 is all but a lock to put up a massive score.</p>
                <p><strong>Prediction:</strong> pranavj20 takes the massive win here solidly placing him as the top team in the league courtesy of abhiu's gift</p>
              </div>

              <div className="matchup-preview" style={{backgroundColor: '#f9f9f9', border: '2px solid #000', borderRadius: '4px', padding: '10px', margin: '10px 0'}}>
                <h4>audumula vs pranav4789 (anudeep vs pranav p)</h4>
                <p><strong>Key Storylines:</strong> 1-1 bounce-back teams are looking to show that they are here to stay this year as a contender</p>
                <p><strong>X-Factors:</strong> Josh Allen's ceiling vs ARSB's upside. Can audumula contain the Sun God?</p>
                <p><strong>Prediction:</strong> pranav4789's firepower gives them the edge in what should be a high-scoring affair</p>
              </div>

              <h3>⚖️ Revenge Games</h3>

              <div className="matchup-preview" style={{backgroundColor: '#f9f9f9', border: '2px solid #000', borderRadius: '4px', padding: '10px', margin: '10px 0'}}>
                <h4>abhishekD vs kulkdaddy47 (abhishek vs aditya)</h4>
                <p><strong>Key Storylines:</strong> The fallen king meets championship experience! Can Abhishek bounce back from his historic 72-point collapse?</p>
                <p><strong>X-Factors:</strong> Derrick Henry's vs Mahomes-Kelce connection. Two proven winners in must-win territory.</p>
                <p><strong>Prediction:</strong> Desperation makes abhishekD dangerous - expect fireworks from his team as they bounce back</p>
              </div>

              <div className="matchup-preview" style={{backgroundColor: '#f9f9f9', border: '2px solid #000', borderRadius: '4px', padding: '10px', margin: '10px 0'}}>
                <h4>roshik vs swahili28 (roshik vs sahil)</h4>
                <p><strong>Key Storylines:</strong> Saquon's balanced attack faces the Ja'Marr Chase explosion team in a battle of contrasting styles.</p>
                <p><strong>X-Factors:</strong> Can Chase follow up his 36.50-point masterpiece? Barkley needs consistent volume to compete.</p>
                <p><strong>Prediction:</strong> Chase's volatility vs Saquon's reliability - whoever hits their ceiling wins</p>
              </div>

              <h3>🎯 Desperation Battles</h3>

              <div className="matchup-preview" style={{backgroundColor: '#f9f9f9', border: '2px solid #000', borderRadius: '4px', padding: '10px', margin: '10px 0'}}>
                <h4>taahakm vs akhilmetukuru (taaha vs akhil)</h4>
                <p><strong>Key Storylines:</strong> Surprising 2-0 team looks to stay perfect against winless akhilmetukuru fighting for survival.</p>
                <p><strong>X-Factors:</strong> taahakm's improved consistency vs akhilmetukuru's desperation plays. Can 0-2 finally break through?</p>
                <p><strong>Prediction:</strong> taahakm's luck wears off as akhil shows up in a truly must win game</p>
              </div>

              <div className="matchup-preview" style={{backgroundColor: '#f9f9f9', border: '2px solid #000', borderRadius: '4px', padding: '10px', margin: '10px 0'}}>
                <h4>SahitReddi vs abhiu (sahit vs abhiram)</h4>
                <p><strong>Key Storylines:</strong> Ultimate desperation game! Two 0-2 teams battle with loser facing potential season elimination.</p>
                <p><strong>X-Factors:</strong> Bijan Robinson's upside vs abhiu's post-trade roster chaos. How does losing Lamar affect their ceiling?</p>
                <p><strong>Prediction:</strong> SahitReddi's superior talent finally shows up when their backs are against the wall</p>
              </div>
            </div>
          </div>

          <div className="final-assessment">
            <h2 className="section-headline">Final Assessment</h2>
            <p className="assessment-text">
              The league has shown incredible parity through two weeks, with any team capable of explosive performances or spectacular failures. Week 3 will separate the true contenders from the pretenders as we approach the crucial mid-season stretch!
            </p>
          </div>

          <div className="newspaper-footer">
            <div className="footer-line"></div>
            <div className="newspaper-tagline">
              "Your Source for Fantasy Football Excellence Since 2018"
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Week2Newsletter;